import { IOption } from '../../base';

export enum IJobsBoardFormValues {
    search = 'search',
    jobTypes = 'jobTypes',
    isRemote = 'isRemote',
    isHybrid = 'isHybrid',
    location = 'location',
}

export interface IJobsBoardForm {
    [IJobsBoardFormValues.search]: string | undefined;
    [IJobsBoardFormValues.jobTypes]: Record<string, boolean>;
    [IJobsBoardFormValues.isRemote]: boolean;
    [IJobsBoardFormValues.isHybrid]: boolean;
    [IJobsBoardFormValues.location]: Record<string, boolean>;
}

export type IJobBoardFilterTypes =
    | 'dropdown'
    | 'checkbox'
    | 'radio'
    | 'boolean';

export interface IJobsBoardFilter {
    title: string;
    name: string;
    type: IJobBoardFilterTypes;
    options?: Array<IOption>;
    shouldShow?: boolean;
}
